// Persistent footer banner that prompts the user to turn on push
// notifications. Surfaces when the browser supports push but the user
// isn't subscribed. CJ 2026-05-21: schedule-accept + chat + reminders
// all depend on push working, so this nags (with a 7-day snooze on
// "Not now") instead of being a one-time toast.
export function PushOptInBanner({ status, onEnable, onDismiss }) {
  const denied = status === 'denied';
  return (
    <div style={{ position: 'fixed', bottom: 'calc(60px + env(safe-area-inset-bottom, 0px) + 8px)',
                    left: 8, right: 8, zIndex: 1000,
                    background: '#1b2b1b', color: '#fff',
                    borderRadius: 10, padding: '10px 12px',
                    boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
                    display: 'flex', flexDirection: 'column', gap: 8,
                    maxWidth: 540, margin: '0 auto' }}>
      <div style={{ fontSize: 13, fontWeight: 700 }}>🔔 Turn on notifications</div>
      <div style={{ fontSize: 12, color: '#dcdcdc', lineHeight: 1.4 }}>
        {denied
          ? `Your browser is blocking notifications. Open your browser settings for Monarch and switch them on, then refresh — your schedule alerts, chat, and accept reminders won't reach you otherwise.`
          : `Your schedule alerts, chat messages, and accept reminders come through here. Without notifications you'll miss them.`}
      </div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button onClick={onDismiss}
          style={{ background: 'transparent', color: '#bdbdbd', border: '1px solid #3c4a3c',
                    padding: '6px 12px', borderRadius: 6, fontSize: 12, fontWeight: 600,
                    cursor: 'pointer' }}>
          Not now
        </button>
        {!denied && (
          <button onClick={onEnable}
            style={{ background: '#b48a47', color: '#fff', border: 0,
                      padding: '6px 14px', borderRadius: 6, fontSize: 12, fontWeight: 700,
                      cursor: 'pointer' }}>
            Enable
          </button>
        )}
      </div>
    </div>
  );
}
